exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mobile__container__19cXa{background-color:-wix-colors-backgroundColor;box-sizing:border-box}", "", {"version":3,"sources":["/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/layouts/mobile/src/widget/layouts/mobile/mobile.styl","/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/layouts/mobile/mobile.styl"],"names":[],"mappings":"AAAA,0BACE,6CAAA,qBACA,CCCD","file":"mobile.styl","sourcesContent":[".container\n  background-color -wix-colors-backgroundColor\n  box-sizing border-box\n",".container {\n  background-color: -wix-colors-backgroundColor;\n  box-sizing: border-box;\n}\n/*# sourceMappingURL=src/widget/layouts/mobile/mobile.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "mobile__container__19cXa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/layouts/mobile/mobile.styl
// module id = 2582
// module chunks = 1